'use client';
import { memo } from 'react';
import NextLink from 'next/link';
import { Box, Center, Link, HStack, useBoolean, Button } from '@chakra-ui/react';

import HeaderMobileMenu from './HeaderMobileMenu';
import MenuToggle from 'shared/MenuToggle';
import InterText from 'shared/InterText';
import NextImage from 'shared/NextImage';

import {
  EMPTY_OBJECT,
  SECTIONS_IDS,
  ASTONDEVS_URL,
  HEADER_HEIGHTS,
  HEADER_BREAKPOINT,
} from 'constants/global';
import Logo from 'assets/icons/astonLogo.svg';
import { headerNavButtonsData } from 'constants/header';

const Header = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useBoolean(false);

  return (
    <>
      <Box
        as="header"
        id={SECTIONS_IDS.header}
        w="100vw"
        pos="absolute"
        top="0"
        left="0"
        zIndex="sticky"
      >
        <Center
          maxW="1440px"
          minH={HEADER_HEIGHTS}
          p={{ mobile: '8px 16px', tablet: '12px 20px', laptop: '12px 80px' }}
          m="0 auto"
          justifyContent="space-between"
        >
          <Link as={NextLink} href={ASTONDEVS_URL} isExternal>
            <NextImage
              src={Logo}
              alt="Логотип"
              w={{ mobile: '82px', tablet: '100px', laptop: '113px' }}
              h="auto"
              filter={isMobileMenuOpen && 'brightness(0) invert(1)'}
              transition="all 0.3s"
            />
          </Link>

          <HStack
            as="nav"
            aria-label="Главная навигация"
            gap={{ [HEADER_BREAKPOINT]: '32px', laptop: '48px' }}
            hideBelow={HEADER_BREAKPOINT}
          >
            {headerNavButtonsData.map(({ text, onItemClick }, i) => (
              <Button
                key={i}
                role="group"
                w="fit-content"
                h="fit-content"
                bg="transparent"
                p="0"
                _hover={{ color: 'ourGray' }}
                _active={EMPTY_OBJECT}
                onClick={onItemClick}
              >
                <InterText textStyle="b3" transition="all 0.3s">
                  {text}
                </InterText>
              </Button>
            ))}
          </HStack>
        </Center>
      </Box>

      <MenuToggle isOpen={isMobileMenuOpen} onClick={setIsMobileMenuOpen.toggle} />

      <HeaderMobileMenu
        isMenuOpen={isMobileMenuOpen}
        toggleIsMenuOpen={setIsMobileMenuOpen.toggle}
      />
    </>
  );
};

export default memo(Header);
